import React, { memo } from 'react';
import { useGetValue } from 'formydable';
const Condition = /*#__PURE__*/memo(({
  name,
  showWhen,
  children
}) => {
  const value = useGetValue(name);
  return /*#__PURE__*/React.createElement(React.Fragment, null, showWhen(value) ? children : null);
});
export default Condition;